import React from "react";
import InfoCard from "./InfoCard";
import classNames from "classnames";
import { signUpSteps } from "../authHelpers";
import { selectors } from "@ReduxStore/reducers";
import { useSelector } from "react-redux";
import "./AuthInfo.scss";
import { Trans } from "@lingui/react/macro";
import { AuthModalTypes } from "@Src/constants";

function AuthInfo({ screen, isPhone = false, classes }) {
  const signUpStep = useSelector(selectors.getSignUpStep);

  return (
    <div
      className={classNames("AuthInfo", {
        initScreen: signUpStep === signUpSteps.GENERAL,
      })}
    >
      {!isPhone && <div className={classes} />}
      {screen === AuthModalTypes.SIGN_IN && !isPhone && (
        <div className="AuthInfo-signInText t-headline-med">
          <Trans>
            Sign in to start
            <div>exploring your savings</div>
          </Trans>
        </div>
      )}

      {screen === AuthModalTypes.SIGN_UP && <InfoCard />}
    </div>
  );
}

export default AuthInfo;
